export const HONEYPOT_IDS = ['email', 'address', 'street', 'zip', 'city', 'phone']

export const appendHoneypotData = (formData: FormData) => {
  HONEYPOT_IDS.map((id: string) => {
    const element: HTMLInputElement = document.getElementById(id) as HTMLInputElement
    formData.append(id, element?.value)
  })

  return formData
}
